// extracted by mini-css-extract-plugin
export default {"container":"AuthBox-container-0939400effd5d2e8067fc9264b2d1f35"};